import { render } from "./AddNormativeDocument.vue?vue&type=template&id=3b1cd0d0"
import script from "./AddNormativeDocument.vue?vue&type=script&lang=js"
export * from "./AddNormativeDocument.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__